import { api } from ".";

export const fetchChurches = async (page = 0, size = 10): Promise<ApiResponse<Churches>> => {
  const res = await api.get<ApiResponse<Churches>>(`/church?pageSize=${size}&page=${page}`);
  return res.data;
};

export const searchChurches = async (
  query = "",
  page = 0,
  size = 10
): Promise<ApiResponse<Churches>> => {
  const res = await api.get<ApiResponse<Churches>>(
    `/church/search?searchKey=${query}&pageSize=${size}&page=${page}`
  );
  return res.data;
};

export const fetchChurchAudioSermons = async (
  churchId: string,
  page = 0,
  size = 10
): Promise<ApiResponse<Sermons>> => {
  const res = await api.get<ApiResponse<Sermons>>(
    `/church/${churchId}/sermons?type=Audio&pageSize=${size}&page=${page}`
  );
  return res.data;
};

export const fetchChurchVideoSermons = async (
  churchId: string,
  page = 0,
  size = 10
): Promise<ApiResponse<Videos>> => {
  const res = await api.get<ApiResponse<Videos>>(
    `/church/${churchId}/sermons?type=Video&pageSize=${size}&page=${page}`
  );
  return res.data;
};
